import { TFunction } from 'i18next';
import _get from 'lodash/get';
import { Site } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import { CellProps, Column } from '@lib/components/Table/types';
import { ChipTypes } from '@lib/components/Chip/Chip';

type ColumnsArgs = {
  t: TFunction<'translation', undefined>;
};

export default function getSitesColumns({ t }: ColumnsArgs): Column<Site>[] {
  return [
    {
      id: 'code',
      Header: t('code'),
      accessor: 'code',
      Cell: (props: CellProps<Site>) => <TextCell {...props} />,
      minWidth: 160,
      maxWidth: 220,
      width: 200,
      sortable: true,
    },
    {
      id: 'name',
      Header: t('site-name'),
      accessor: 'name',
      Cell: (props: CellProps<Site>) => <TextCell {...props} />,
      sortable: true,
      minWidth: 200,
      maxWidth: 400,
    },
    {
      id: 'sectorName',
      Header: t('sector'),
      Cell: (props: CellProps<Site>) => {
        const label = _get(props, 'item.sector.name', '');
        const color = _get(
          props,
          'item.sector.color',
          ChipTypes.chipGray,
        ) as ChipTypes;
        if (!label) return '-';
        return <ChipCell label={label} type={color} />;
      },
      sortable: true,
      minWidth: 200,
      maxWidth: 350,
    },
  ];
}
